var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudienceMenuIcon = function SvgAudienceMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#5c34cd",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C5.685 3 3 5.71 3 9c0 3.315 2.685 6 6 6 3.29 0 6-2.685 6-6 0-3.29-2.71-6-6-6m0 10.452A4.44 4.44 0 0 1 4.548 9 4.455 4.455 0 0 1 9 4.548c2.444 0 4.452 2.008 4.452 4.452A4.455 4.455 0 0 1 9 13.452m0-7.549A3.103 3.103 0 0 0 5.903 9 3.087 3.087 0 0 0 9 12.097 3.103 3.103 0 0 0 12.097 9c0-1.694-1.403-3.097-3.097-3.097m0 4.645A1.53 1.53 0 0 1 7.452 9c0-.847.677-1.548 1.548-1.548A1.56 1.56 0 0 1 10.548 9c0 .871-.701 1.548-1.548 1.548"
  })));
};
export default SvgAudienceMenuIcon;